import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Box } from '@mui/material';
import { acceptInvite } from '../services/apiService.ts';
import { useSnackbar } from 'notistack';

const AcceptInvitePage: React.FC = () => {
  const { token } = useParams();
  const [firstName, setFirst] = useState('');
  const [lastName, setLast] = useState('');
  const [password, setPwd] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      await acceptInvite({ token: token!, firstName, lastName, password });
      enqueueSnackbar('Cont creat. Redirectionare catre loginul canonic de superadmin...', { variant: 'success' });
      navigate('/login', { replace: true });
    } catch (e: any) {
      if (e.response?.status === 410) {
        enqueueSnackbar('Link expirat. Cere alta invitatie.', { variant: 'error', autoHideDuration: 6000 });
      } else if (e.response?.status === 409) {
        enqueueSnackbar('E-mail deja utilizat.', { variant: 'error', autoHideDuration: 6000 });
      } else {
        enqueueSnackbar(e.response?.data?.message || e.message, { variant: 'error', autoHideDuration: 6000 });
      }
    }
  };

  return (
    <Box maxWidth={400} mx="auto" mt={4} display="flex" flexDirection="column" gap={2}>
      <h2>Accept Invitation</h2>
      <TextField label="First Name" value={firstName} onChange={(e) => setFirst(e.target.value)} />
      <TextField label="Last Name" value={lastName} onChange={(e) => setLast(e.target.value)} />
      <TextField label="Password" type="password" value={password} onChange={(e) => setPwd(e.target.value)} />
      <Button variant="contained" onClick={handleSubmit} disabled={!firstName || !lastName || !password}>
        Create Account
      </Button>
    </Box>
  );
};

export default AcceptInvitePage;
